import React, {useContext, useEffect} from 'react'
import headbandContext from 'contexts/headband'

export default function Reconversion() {
    const {setHeadband} = useContext(headbandContext)
    useEffect(() => {
        setHeadband({
            title :  "Reconversion professionnelle",
            icon : "picto_fiche_contact.svg",
            color : "bckGreen"
        })
    }, [])
    return (
        <div  className='page enCours flex center'>
            Page en cours
        </div>
    )
}
